import { type ILayoutConfig } from '@/providers';

// Defining the layout configuration for the errors layout
const errorsLayoutConfig: ILayoutConfig = {
  name: 'errors-layout', // Unique identifier for the layout
  options: {} // Placeholder for layout options, can be customized later
};

export { errorsLayoutConfig };
